import { render, staticRenderFns } from "./edit-topic.vue?vue&type=template&id=91ffaddc&"
import script from "./edit-topic.vue?vue&type=script&lang=ts&"
export * from "./edit-topic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "edit-topic.vue"
export default component.exports